import { BrowserSearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'allinurl' },
  { name: 'inurl' },
  { name: 'allintitle' },
  { name: 'intitle' },
  { name: 'allintext' },
  { name: 'intext' },
  { name: 'allinanchor' },
  { name: 'inanchor' },
  { name: 'filetype' },
  { name: 'site' },
  { name: 'related' },
  { name: 'info' },
  { name: 'cache' },
  { name: 'define' },
  { name: 'link' },
  { name: 'after' },
  { name: 'before' },
  { name: 'ext' }
]

const MAX_TERMS = 32

const defaultSyntaxGuideUrl = 'https://support.google.com/websearch/answer/2466433?hl=en'

class GoogleEngine extends BrowserSearchEngine {
  constructor (fieldSpecifiers) {
    super('Google')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }
  formulateQuery (query) {
    return 'https://www.google.com/search?q=' + query
  }
  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    const r = m ? [m] : []
    if (this.countTerms(queryGraphData) > MAX_TERMS) {
      r.push(this.formatErrorMessage('termLimit', MAX_TERMS))
    }
    return r
  }
}

export default GoogleEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/GoogleEngine.js